import { useSelector } from 'react-redux';

import { getEmail } from '@domains/user/store/slices/user-slice/user-slice';
import { InternalModule } from '../launch.constants';
import { ExternalTool } from '../../../config/external-tools';
import { NavBar, NavBrand, NavCenter, NavTitle, NavActions, NavEmail, LogoutButton } from '../styles';
import { SearchBar } from './SearchBar';
import { FlagDropdown } from './FlagDropdown';

interface LaunchNavBarProps {
  visibleModules: InternalModule[];
  onOpenModule:   (path: string) => void;
  onOpenTool:     (tool: ExternalTool) => void;
  onLogout:       () => void;
}

export const LaunchNavBar = ({ visibleModules, onOpenModule, onOpenTool, onLogout }: LaunchNavBarProps) => {
  const email = useSelector(getEmail);

  return (
    <NavBar>
      <NavBrand>
        <NavTitle>Polynator</NavTitle>
      </NavBrand>

      <NavCenter>
        <SearchBar
          visibleModules={visibleModules}
          onOpenModule={onOpenModule}
          onOpenTool={onOpenTool}
        />
      </NavCenter>

      <NavActions>
        {email && <NavEmail>{email}</NavEmail>}
        <FlagDropdown />
        <LogoutButton onClick={onLogout}>Cerrar sesión</LogoutButton>
      </NavActions>
    </NavBar>
  );
};
